import { create_contact_request_epoch, read_contact_display_payload, read_contact_patch } from '../utils/contact/contact_access';
import axios from 'axios';
import store from '../redux/store';
import { expireSession } from '../services/authentication/SessionService';
import i18n from '../localization/i18next';
import { read_niffler_admin_path } from '../router/niffler_routes';

const clients = require('../config/index').config
const client = process.env.REACT_APP_CLIENT;
const authClient = process.env.REACT_APP_AUTH_CLIENT;
const lang = i18n.language ? i18n.language : 'el';

const contactRequests = create_contact_request_epoch();
const is_contact_request = request => /\/(prospects|leads|clients)(\/|$)/.test(request?.url || '');
const is_contact_mutation = request => is_contact_request(request) && !/get|search|filter|timeline|performance|preview|pending/i.test(request?.url || '') && ['post', 'patch', 'put', 'delete'].includes(request?.method);

export function jwtReqInterceptor() {

    axios.interceptors.request.use(request => {

        const token = store.getState()?.user?.token;

        request.headers.Authorization = `${token}`;

        if (/\/sales(?:\/|$)/.test(window.location.pathname) && /\/prospects\/(editBrand|assignBrandSeller|updateBrandStatus|toggleBrandSales|createBrandComment|createBrandCalendar)$/.test(request.url || '')) {
            request.url = request.url.replace('/prospects/', '/prospects/sales/');
        }
        if (is_contact_request(request)) {
            request.contactStamp = contactRequests.begin(store.getState()?.user?.user?.sub, is_contact_mutation(request));
            if (request.data) request.data = read_contact_patch(request.data);
        }
        return request;
    });
}

export function jwtResInterceptor() {

    axios.interceptors.response.use(response => {
        if (is_contact_request(response.config) && response.config.contactStamp) {
            if (!contactRequests.current(response.config.contactStamp, store.getState()?.user?.user?.sub)) {
                //return Promise.reject(Object.assign(new Error('Discarded stale contact response'), { code: 'STALE_CONTACT_RESPONSE', cancelled: true }));
            console.error("We don't know what this is about, but: 'Discarded stale contact response'")
            }
            response.data = read_contact_display_payload(response.data);
            if (is_contact_mutation(response.config)) contactRequests.invalidate();
        }
        return response;
    }, err => {
        const code = err?.response?.data?.code;

        console.log(code)
        if (code == 403) {
           window.location.replace(`${clients[client]}${read_niffler_admin_path(lang, 'access-denied')}`)
        }
        else if (code == 401) {
            window.location.assign(`${clients[authClient]}/${lang}/auth?redirectUri=${window.location.href}`)
         }

        return Promise.reject(err);
    })
}
